import { useEvent } from '../Checkout/EventProvider';

const useProject = () => useEvent().event.project;

export default useProject;
